import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5fa76ab6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5fa76ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa76ab6",
  null
  
)

export default component.exports